import CryptoJS from 'crypto-js';

export function generateHmac(requestId: string, method?: string): string;

export function generateHmac(options: { type: 'body'; body: object }): string;

export function generateHmac(
  arg: string | { type: 'body'; body: object },
  method: string = 'POST',
): string {
  if (typeof arg === 'object' && arg.type === 'body') {
    return CryptoJS.HmacSHA256(
      JSON.stringify(arg.body),
      import.meta.env.VITE_FEEDBACK_SECRET_KEY,
    ).toString(CryptoJS.enc.Hex);
  }

  return CryptoJS.HmacSHA256(
    `${method}|${arg}`,
    import.meta.env.VITE_HMAC_SECRET,
  ).toString(CryptoJS.enc.Hex);
}
